

import { createReducer } from '@reduxjs/toolkit';
import { ENABLE_TESTS, SET_APP_PARAMETERS } from '../actions/AppActions';

const initialState = {
    enabledTests: {},
    a1LogoUrl: 'https://a1media.antena1.com.br/image/misc/logo/Logo-default.png',
    a1LogoAlt: 'Logo Antena 1',
    headerBarText: 'Ouça agora a rádio online mais ouvida!',
    headerBarTitle: 'Ouça agora a rádio online mais ouvida!',
    headerBarLink: '/ouvir-radio-online',
    headerBarStartColor: '#3464c5',
    headerBarEndColor: '#0b6fff',
    maintenance: false, // @TODO add some visual indication when this is true (like the update bar, for example)
    prerollAdTagUrls: {
        prerollAdTagUrlAdManager: null,
        prerollAdTagUrlTargetSpot: null,
    },
    videoPrerollAdTagUrl: null,
};

const app = createReducer(initialState, (builder) => {
    builder
        .addCase(ENABLE_TESTS, (state, action) => {
            // @TODO use the setapparameters action here as well
            // enabledTests needs to be an array of objects ({test: value})!
            state.enabledTests = action.enabledTests;
        })
        .addCase(SET_APP_PARAMETERS, (state, action) => ({
            ...state,
            ...action.appParameters,
        }));
});

export default app;
